<p class="rs-tit3" data-cy="settingsAndFaq">
  {{ settingsTitle }}
</p>
<div class="rs-entrypoint-container">
  <a
    (click)="onClickOfBillPreferences()"
    data-cy="myBillGoToBillSettings"
    data-tms-event="button-click"
    data-tms-button-name="go to: mybill.settings"
    [attr.data-tms-button-zone]="zone"
    [attr.data-tms-message-info]="billingAccount?.accountNumber ?? ''"
    [attr.data-tms-context]="billingDocument?.reference ?? ''"
    class="rs-entrypoint"
  >
    <span class="rs-entrypoint-title">{{ settingsLinkLabel }}</span>
    <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
  </a>
</div>
<div class="panel rs-bg-grey2">
  <my-bill-faq
    [billingDocument]="billingDocument"
    [billingAccount]="billingAccount"
    [zone]="zone"
    [isResUser]="isResUser"
  ></my-bill-faq>
</div>
